import React, { useEffect, useState } from 'react';
import { getComments, createComment } from '../../lib/api';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Clock, MessageSquare, Plus, User } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { toast } from 'sonner';

export const ChantierTab = ({ dossier }) => {
    const dossierId = dossier.id;
    const [comments, setComments] = useState([]);
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try {
            const res = await getComments(dossierId);
            setComments(res.data || []);
        } catch {
            setComments([]);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => { load(); }, [dossierId]);

    const handleAdd = async () => {
        if (!content.trim()) return;
        try {
            await createComment({ dossier_id: dossierId, contenu: content });
            setContent('');
            await load();
            toast.success('Commentaire ajouté');
        } catch (e) {
            toast.error(e.response?.data?.detail || 'Erreur lors de l\'ajout');
        }
    };

    return (
        <div className="bg-white border border-[#E4E4E7] p-6 rounded-sm space-y-4" data-testid="chantier-tab">
            <h3 className="font-semibold flex items-center gap-2">
                <MessageSquare className="w-4 h-4 text-[#E85A24]" /> Commentaires chantier
            </h3>

            <div className="flex gap-2">
                <Textarea
                    placeholder="Ajouter un commentaire (horodaté, visible par l'équipe)..."
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    rows={2}
                    className="rounded-sm"
                    data-testid="chantier-comment-input"
                />
                <Button
                    onClick={handleAdd}
                    className="bg-[#E85A24] hover:bg-[#CC4D1C] text-white rounded-sm self-start"
                    data-testid="add-chantier-comment-btn"
                >
                    <Plus className="w-4 h-4" />
                </Button>
            </div>

            {loading ? (
                <p className="text-sm text-[#52525B]">Chargement...</p>
            ) : comments.length === 0 ? (
                <p className="text-sm text-[#52525B] italic">Aucun commentaire</p>
            ) : (
                <div className="space-y-3">
                    {comments.map((c) => (
                        <div key={c.id} className="flex gap-3 p-3 border border-[#E4E4E7] rounded-sm" data-testid={`chantier-comment-${c.id}`}>
                            <div className="w-8 h-8 rounded-full bg-[#E85A24]/10 flex items-center justify-center shrink-0">
                                <User className="w-4 h-4 text-[#E85A24]" />
                            </div>
                            <div className="flex-1">
                                <div className="flex items-center gap-2 text-xs text-[#52525B] mb-1">
                                    <span className="font-semibold text-[#0A0A0A]">{c.created_by_name || 'Utilisateur'}</span>
                                    <Clock className="w-3 h-3" />
                                    <span>{c.created_at ? format(new Date(c.created_at), 'dd/MM/yyyy HH:mm', { locale: fr }) : '-'}</span>
                                </div>
                                <p className="text-sm whitespace-pre-wrap">{c.contenu || c.content}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
